const defaultState = {
  user: {},
  error: null,
  fetching: false,
  fetched: false
};

const completeRegistrationReducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'COMPLETE_REGISTRATION_FETCH_PENDING': {
      return {
        ...state, error: null, fetching: true
      };
    }
    case 'COMPLETE_REGISTRATION_FETCH_FULFILLED': {
      return {
        ...state, fetching: false, fetched: true, error: null, user: action.payload
      };
    }
    case 'COMPLETE_REGISTRATION_FETCH_REJECTED': {
      return {
        ...state,
        fetching: false,
        fetched: false,
        error: action.payload
      };
    }
    default: {
      break;
    }
  }

  return state;
};

export default completeRegistrationReducer;


// WEBPACK FOOTER //
// ./src/reducers/completeRegistration.js